import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import GenericForm from '@/components/GenericForm.vue'
import PotenciaService from '@/services/PotenciaService'
import { criarPotencia, storageLogoPotenciaRef } from '@/shareds/sharedsPotencia'
import { Potencia, InputPotencia } from '../../../common/types/Potencia'
import { obrigatorio } from '@/shareds/regras'
import { storage } from '@/firebase'
import { v4 as uuidv4 } from 'uuid'
import dayjs from 'dayjs'
import { onBeforeRouteLeave } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormPotencia',
  props: {
	novo: { type: Boolean, default: false },
	id: { type: String },
},
  setup(__props) {



const service = PotenciaService

const genericForm = ref<{ validarSaida: () => false | void }>()
const logoInput = ref<HTMLInputElement>()

const novaLogo = ref<File | null>(null)
const logoPreview = ref('')

function logoPotencia(potencia: Potencia) {
	return logoPreview.value || potencia.urlLogo
}

function removerLogo(potencia: InputPotencia) {
	potencia.urlLogo = ''
	novaLogo.value = null
}

function onLogoChange() {
	const input = logoInput.value!
	if (!input.files) return
	const [file] = input.files
	novaLogo.value = file
}

watch(novaLogo, (logo) => {
	if (!logo) {
		logoPreview.value = ''
		return
	}
	const reader = new FileReader()

	reader.addEventListener('load', () => {
		logoPreview.value = reader.result as string
	}, false)

	reader.readAsDataURL(logo)
}, { immediate: true })

async function beforeSave(potencia: InputPotencia) {
	if (!novaLogo.value) return {
		...potencia,
	}

	const ref = storage.ref(`${storageLogoPotenciaRef}/${uuidv4()}`)
	const snapshot = await ref.put(novaLogo.value, {
		customMetadata: {
			fileName: novaLogo.value.name,
		},
	})
	const donwloadUrl = await snapshot.ref.getDownloadURL()
	return {
		...potencia,
		urlLogo: donwloadUrl || '',
	}
}

onBeforeRouteLeave((to, from, next) => {
	next(genericForm.value!.validarSaida())
})

function dataDaProximaPalavraSemestral(){
	const expirations = [
		dayjs('10', 'MM'),
		dayjs('4', 'MM'),
	]
		.map(date => date.year(new Date().getFullYear()))
		.map(date => dayjs().isAfter(date)
			? date.add(1, 'y')
			: date
		)
		.sort((dataA, dataB) => {
			return dataA.diff(dataB)
		})
	return expirations[0].format('DD/MM/YYYY')
}

return { __sfc: true,service, genericForm, logoInput, novaLogo, logoPreview, logoPotencia, removerLogo, onLogoChange, beforeSave, dataDaProximaPalavraSemestral, GenericForm, criarPotencia, obrigatorio }
}

})